import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useAttachmentStore = defineStore('attachments', () => {
  const documentsUrl = ref([]);
  const attachment = ref(null);
  const pickedFiles = ref([]);

  function setDocumentsUrl(doc) {
    if (Array.isArray(doc)) {
      documentsUrl.value = doc;
    } else {
      documentsUrl.value.push(doc);
    }
  }

  function unSetDocumentsUrl(docToRemove) {
    documentsUrl.value = documentsUrl.value.filter(d => d.fileId !== docToRemove.fileId);
  }

  function setAttachment(att) {
    attachment.value = att;
  }

  function setPickedFiles(files) {
    pickedFiles.value = files;
  }

  return {
    documentsUrl,
    attachment,
    pickedFiles,
    setDocumentsUrl,
    unSetDocumentsUrl,
    setAttachment,
    setPickedFiles
  };
});
